import MyCreditReport from './MyCreditReport'

export default MyCreditReport
